export const faq = [
    {
        question: "Wat is het doel van deze tool?",
        answer: "Deze tool helpt projectteams bij het invullen van duurzaamheid en ruimtelijke kwaliteit in dijkversterkingsprojecten. Het biedt handvatten om deze aspecten gedurende het project te borgen en maakt het mogelijk om tussentijdse resultaten en afwegingen te rapporteren, zodat de prestaties inzichtelijk worden gemaakt."
    },
    {
        question: "Hoe gaat deze tool om met privacy en cookies?",
        answer: "Deze tool gebruikt alleen essentiële cookies. Deze cookies zijn nodig voor de werking van de website. De cookies worden gebruikt om te gebruiker ingelogd te houden en voor beveiliging. Deze cookies worden niet gebruikt voor advertentie, marketing, sociale media, tracking of analytics. Deze cookies worden niet gedeeld met derden."
    },
    {
        question: "Hoe krijg ik toegang tot een project?",
        answer: "U krijgt toegang tot projecten via de organisatie waar u lid van bent. Als u toegang nodig heeft tot een specifiek project, neem dan contact op met de organisatiebeheerder of applicatiebeheerder van uw organisatie."
    },
    {
        question: "Wat zijn aspecten en hoe gebruik ik ze?",
        answer: "Aspecten zijn de verschillende duurzaamheidsthema's van de duurzaamheidsroos. Elk aspect heeft bijbehorende KPI's (Kritieke Prestatie Indicatoren) die u kunt gebruiken om de duurzaamheidsprestaties van uw project te meten en te rapporteren. U kunt aspecten bekijken via het menu 'Aspecten'."
    },
    {
        question: "Hoe voeg ik een nieuw project toe?",
        answer: "Als u organisatiebeheerder bent, kunt u via de projectenpagina een nieuw project aanmaken. Klik op de knop 'Nieuw project' en vul de benodigde gegevens in. Zorg ervoor dat u alle verplichte velden invult voordat u het project opslaat."
    },
    {
        question: "Wat is het verschil tussen een organisatiebeheerder en een applicatiebeheerder?",
        answer: "Een organisatiebeheerder beheert gebruikers en projecten binnen zijn of haar eigen organisatie. Een applicatiebeheerder heeft toegang tot alle organisaties en kan gebruikers, organisaties en aspecten beheren op applicatieniveau."
    },
    {
        question: "Hoe kan ik feedback geven over de tool?",
        answer: "U kunt feedback geven via het feedbackformulier dat u kunt openen via het vraagteken-icoon in de rechterbenedenhoek van het scherm. Selecteer het type feedback en beschrijf uw opmerking of suggestie zo gedetailleerd mogelijk."
    },
    {
        question: "Wat moet ik doen als ik mijn wachtwoord ben vergeten?",
        answer: "Als u uw wachtwoord bent vergeten, kunt u dit zelf resetten via het wachtwoord reset formulier op de inlogpagina."
    },
    {
        question: "Hoe werk ik met KPI's in mijn project?",
        answer: "KPI's zijn gekoppeld aan aspecten en worden gebruikt om de duurzaamheidsprestaties te meten. In de verschillende fasen van uw project kunt u KPI's invullen en scores toekennen. Navigeer naar uw project en volg de stappen in de projectfase om KPI's in te vullen."
    },
    {
        question: "Kan ik gegevens exporteren uit de tool?",
        answer: "Ja, in verschillende onderdelen van de tool zijn exportfuncties beschikbaar. Kijk naar de download- of exportknoppen bij projecten, rapportages en overzichten. De exacte exportmogelijkheden kunnen per onderdeel verschillen."
    },
    {
        question: "Wat zijn de verschillende projectfasen?",
        answer: "Projecten doorlopen verschillende fasen: de voorbereidingsfase (projectoverzicht, aanvullende informatie), en de ontwerpfase (advies, ontwerpen, discussie). Elke fase heeft specifieke stappen die moeten worden doorlopen om de duurzaamheid en ruimtelijke kwaliteit te borgen."
    },
    {
        question: "Hoe kan ik andere gebruikers toevoegen aan mijn organisatie?",
        answer: "Als organisatiebeheerder kunt u via het beheerpaneel nieuwe gebruikers toevoegen aan uw organisatie. Ga naar 'Beheer' en selecteer 'Gebruikersbeheer' om gebruikers toe te voegen of te beheren."
    },
    {
        question: "Wat gebeurt er met mijn gegevens als ik uitlog?",
        answer: "Uw gegevens worden automatisch opgeslagen wanneer u wijzigingen aanbrengt. Wanneer u uitlogt, blijven al uw ingevoerde gegevens behouden en kunt u later weer inloggen om verder te werken aan uw projecten."
    },
    {
        question: "Hoe kan ik zien welke projecten ik heb?",
        answer: "U kunt al uw projecten bekijken via de 'Projecten' pagina in het hoofdmenu. Hier ziet u een overzicht van alle projecten waar u toegang toe heeft, gesorteerd op organisatie."
    },
    {
        question: "Wat moet ik doen als ik een foutmelding zie?",
        answer: "Als u een foutmelding ziet, probeer dan eerst de pagina te verversen. Als het probleem aanhoudt, gebruik dan het feedbackformulier om de foutmelding te rapporteren. Vermeld daarbij zoveel mogelijk details over wat u aan het doen was toen de fout optrad."
    },
    {
        question: "Kan ik mijn profielgegevens wijzigen?",
        answer: "Ja, u kunt uw profielgegevens wijzigen via het profielmenu (klik op uw naam/accounticoon rechtsboven). Hier kunt u uw naam, e-mailadres en wachtwoord aanpassen."
    },
    {
        question: "Hoe werkt de rapportagefunctionaliteit?",
        answer: "De tool maakt automatisch rapportages op basis van de gegevens die u invult in de verschillende projectfasen. U kunt deze rapportages bekijken en exporteren via de voortgangspagina van uw project. De rapportages geven inzicht in de duurzaamheidsprestaties en afwegingen die zijn gemaakt."
    }
];

